<template>
  <v-container style="margin-bottom: 10%; min-height: 100%">
    <v-autocomplete
      :items="organizationsList"
      v-model="orgSelected"
      label="Institución"
      @change="filterOrganizations"
    ></v-autocomplete>
    <v-layout>
      <v-card class="masterCard">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          ref="table"
          :headers="headers"
          :items="filteredForms"
          :items-per-page="5"
          :rows-per-page="20"
          :search="search"
          :loading="loading"
          @click:row="viewForm"
        >
          <template v-slot:item.controls="{ item }">
            <!-- stop prop prevent to trigget the click row event -->
            <td v-if="enablePublish(item)" @click.stop="publish(item.code)">
              <v-btn color="#015CAB" style="color: white">Publicar</v-btn>
            </td>
            <td v-if="enableApprove(item)" @click.stop="approve(item.code)">
              <v-btn color="#01aa23" style="color: white; margin-left: 5px"
                >aprobar</v-btn
              >
            </td>
            <td v-if="enableReject(item)" @click.stop="reject(item.code)">
              <v-btn color="#E1251B" style="color: white; margin-left: 5px"
                >Rechazar</v-btn
              >
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetAllForms,
  approveForm,
  rejectForm,
  getWithExpiry,
  publishForm,
  getAuxiliarByType,
} from "@/utils/apiRequest";
import { getAnswer } from "@/utils/utils";
export default {
  data() {
    return {
      forms: [],
      filteredForms: [],
      admin: false,
      search: "",
      orgSelected: "",
      loading: true,
      organizationsList: [""],
      statusMap: new Map(),
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Nombre del R.A", value: "name" },
        { text: "Dominio del R.A", value: "domain" },
        { text: "Subdominio del R.A", value: "subdomain" },
        {
          text: "Sector",
          value: "sector",
        },
        { text: "Institución", value: "org" },
        { text: "Fecha de creación", value: "date" },
        { text: "Fecha de actualización", value: "updateDate" },
        { text: "Responsable de digitación", value: "user.userName" },
        {
          text: "Responsable de la validación",
          value: "responsable.userName",
        },

        { text: "Estatus", value: "status" },
        { text: "", value: "controls", width: "20%" },
      ],
    };
  },
  async mounted() {
    let response = await GetAllForms();
    this.statusMap.set("summited", "digitado sin validar");
    this.statusMap.set("approved", "digitado validado");
    this.statusMap.set("published", "validado para publicación");
    this.statusMap.set("rejected", "rechazado");

    this.statusMap.set("digitado sin validar", "summited");
    this.statusMap.set("digitado validado", "approved");
    this.statusMap.set("validado para publicación", "published");
    this.statusMap.set("rechazado", "rejected");

    if (response.data.status == "success") {
      this.forms = response.data.forms;
      this.forms.forEach((form) => {
        form.domain = getAnswer(form, "Dominio actividad estadística");
        form.subdomain = getAnswer(
          form,
          "Subdominio de la actividad estadística"
        );
        form.goal = getAnswer(form, "¿Cuál es el objetivo del R.A?");
        form.observationUnit = getAnswer(
          form,
          "¿Cuál(es) es (son) la (s) unidad (es) de observación del R.A?"
        );
        form.name = getAnswer(form, "Nombre del Registro Administrativo");
        form.sector = getAnswer(form, "sector");

        form.org = getAnswer(
          form,
          "Nombre de la institución responsable del R.A"
        );
        let date = new Date(form.updateDate);
        form.updateDate = date.toLocaleString();

        date = new Date(form.date);
        form.date = date.toLocaleString();
        form.status = this.statusMap.get(form.status);
      });

      this.filteredForms = this.forms;
      this.loading = false;
    }

    response = await getAuxiliarByType(
      "Nombre de la institución responsable del R.A"
    );

    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.organizationsList.push(aux.value);
        });
      }
      this.organizationsList = this.organizationsList.sort();
    }
  },
  methods: {
    viewForm(form) {
      try {
        const path = `/registros/${form.id}`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    async approve(formID) {
      var approved = await approveForm(formID);
      if (approved.data.status) {
        window.location.reload();
      }
    },
    async reject(formID) {
      var reject = await rejectForm(formID);
      if (reject.data.status) {
        window.location.reload();
      }
    },
    async publish(formID) {
      var publish = await publishForm(formID);
      if (publish.data.status) {
        window.location.reload();
      }
    },
    enablePublish(form) {
      let user = JSON.parse(getWithExpiry("user"));
      if (
        this.statusMap.get(form.status) == "approved" &&
        this.statusMap.get(form.status) != "published" &&
        (form.responsableID == user.id || user.roles.includes("admin"))
      ) {
        return true;
      }
      return false;
    },
    enableApprove(form) {
      let user = JSON.parse(getWithExpiry("user"));
      if (
        this.statusMap.get(form.status) != "approved" &&
        this.statusMap.get(form.status) != "published" &&
        (form.responsableID == user.id || user.roles.includes("admin"))
      ) {
        return true;
      }
      return false;
    },
    enableReject(form) {
      let user = JSON.parse(getWithExpiry("user"));
      if (
        this.statusMap.get(form.status) != "rejected" &&
        (form.responsableID == user.id || user.roles.includes("admin"))
      ) {
        return true;
      }
      return false;
    },

    filterOrganizations(value) {
      this.filteredForms = this.forms;
      this.filteredForms = this.filteredForms.filter((form) => {
        return form.org === value || value == "";
      });
    },
  },
};
</script>

<style scoped lang="css">
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 25% 0 0 0;
}
</style>